import { useAuth } from 'hooks';
import { useEffect } from 'react';
import { reloadIfNewBuildIsAvailable } from 'services/appVersion';
//import { useCompany } from 'hooks';
const EIGHT_HOURS = 8 * 60 * 60 * 1000;

export const isSessionExpired = () => {
  const loginTime = localStorage.getItem('loginTime');
  if (!loginTime) return false;

  const loginTimestamp = new Date(loginTime).getTime();
  return Date.now() - loginTimestamp >= EIGHT_HOURS;
};

const DetectRefresh = () => {
  //const { refreshFew } = useCompany();
  const { logout } = useAuth();
  useEffect(() => {
    void reloadIfNewBuildIsAvailable();

    if (performance.navigation.type === 1) {
      console.log('Page was refreshed (F5 or Ctrl+R)');
      if (isSessionExpired()) {
        alert('Your session has expired. Please login again.');
        logout();
        window.location.href = '/';
      }
      //refreshFew();
    } else {
      console.log('Not a refresh (normal navigation)');
    }
    localStorage.removeItem("lastRowId");
  }, [logout]);

  return null; // No UI
};

export default DetectRefresh;
